import { render } from "./index.vue?vue&type=template&id=199b063b&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=199b063b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199b063b"],['__file',"src/views/jbh/achievementManage/accountAppeal/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "199b063b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('199b063b', __exports__)) {
    console.log('reload')
    api.reload('199b063b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=199b063b&scoped=true", () => {
    console.log('re-render')
    api.rerender('199b063b', render)
  })

}


export default __exports__